import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { useGetSelectedWorkspace } from './workspace';

const selectWorkspaces = state => state.workspace.workspaces;
const selectWorkspaceIdToCheck = (state, workspaceIdToCheck) =>
  workspaceIdToCheck;

const selectRoleLimits = createSelector(
  [selectWorkspaces, selectWorkspaceIdToCheck],
  (workspaces, workspaceIdToCheck) => {
    return workspaces.find(ws => ws.id === workspaceIdToCheck)?.memberLimits;
  }
);

export const useRoleLimit = (limitName, workspaceId = null) => {
  const selectedWorkspace = useGetSelectedWorkspace();
  const workspaceIdToCheck = workspaceId || selectedWorkspace.id;

  const allRoleLimits = useSelector(state =>
    selectRoleLimits(state, workspaceIdToCheck)
  );

  return limitName ? allRoleLimits?.[limitName] : allRoleLimits;
};
